<template>
  <div class="mod_column_flex mod_align_item_center">
    <div class="error_title"></div>
    <img class="error_warning" src="../assets/icon_warning.png"/>
    <p class="error_text">请在微信或支付宝APP内扫码支付</p>
  </div>
</template>

<script>
export default {
  name: "Error"
}
</script>

<style scoped lang="less">
.error_title{
  width: 100%;
  height: 88px;
  background: #326FE0;
}
.error_warning{
  width: 80px;
  height: 80px;
  margin-top: 80px;
}
.error_text{
  height: 24px;
  font-weight: 500;
  font-size: 17px;
  color: #262626;
  letter-spacing: 0;
  text-align: center;
  line-height: 24px;
  margin-top: 16px;
}
</style>
